"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyToClipboard = void 0;

// Copy the provided text to clipboard. Returns true, if the text was copied. Returns false if the copy failed.
var copyToClipboard = function copyToClipboard(text) {
  if (document.execCommand) {
    var textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    return true;
  }

  return false;
};

exports.copyToClipboard = copyToClipboard;
//# sourceMappingURL=copy-to-clipboard.js.map